import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { ConfigList } from './ConfigList';

export const AdminConfigs = () => {
    const navigate = useNavigate();

    const handleCreateConfig = () => {
        navigate('/admin/configs/create');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%',
                height: '100%',
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 3, pb: 2 }}>
                <Typography variant="h5">Configs</Typography>
                <Button variant="contained" onClick={handleCreateConfig}>
                    Create Config
                </Button>
            </Box>
            <Divider />
            <ConfigList />
        </Box>
    );
};
